export const disableRefundMethodOptions = [
  { value: 'bank_transfer', labelKey: 'Transferencia bancaria' },
  { value: 'gift_card', labelKey: 'Tarjeta regalo' },
  { value: 'store_credit', labelKey: 'Crédito en tienda' },
  { value: 'original_payment_method', labelKey: 'Método de pago original' },
]
